import React, { useEffect, useState } from 'react';
import DeleteModal from '../../component/reusable/deleteModal/DeleteModal';
/* import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material'; */
import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, download, EmailBox, Filter, Payment, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAllAdminThunk } from '../../redux/admin/adminSlice';
import { getVendorDetailsThunk, vendorrejectOrAproveThunk } from '../../redux/vendor/vendorSlice';
import { exportDataExcel, fomateDate, handleCopy } from '../../utils/fomateDate';
import AssignModal from '../../component/reusable/assignModal/AssignModal';
import {
    MenuItem,
    Menu,
    Button,
    Paper,
    Typography,
    Box,
    Divider, Grid

} from "@mui/material";
import OrderDetailsProds from '../../component/ordersComps/OrderDetailsProds';
import { ArrowDropDown } from '@mui/icons-material';
import PartList from '../../component/bomComps/PartList/PartList';
import EnquiryList from '../../component/wizardComps/EnquiryList/EnquiryList';
import api from '../../utils/api';
import { deleteProductFromwizardThunk, setwizardrefresh, wizardDetailsThunk } from '../../redux/wizardSlice';
import { toast } from 'react-toastify';
import { deleteProductFromVendorExcessThunk, setvendorExcessrefresh, vendorExcessDetailsThunk } from '../../redux/vendorExcessSlice';



const VendorExcessDetails = (setStatus,) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { id } = useParams()
    const { loading, refresh, orderDetails } = useSelector((state) => state.vendorexcess);
    const enqdetails = encodeURIComponent(JSON.stringify(orderDetails));
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

   

    useEffect(() => {
        dispatch(vendorExcessDetailsThunk(id))
    }, [refresh])

    const changeStatus = async (status) => {
        const datas = {
            id: orderDetails?._id,
            products: orderDetails?.partList,
            status:status
        }
        try {
            const { data } = await api.updatevendorExcessStatus(datas)
            if (data) {
                toast.success('status updated succesfully')
                dispatch(setvendorExcessrefresh())
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || 'something went wrong')
        } finally {
        }
    }


    // Removing a part asks for the Super Admin password first
    const [partToDelete, setPartToDelete] = useState(null)
    const deleteProductFromenq = (selectedId) => setPartToDelete(selectedId)
    const confirmPartDelete = (password) => {
      const data = {
        id: orderDetails?._id,
        partId: partToDelete,
        password
      }
      dispatch(deleteProductFromVendorExcessThunk(data))
      setPartToDelete(null)
    }
    console.log(orderDetails);

    if (loading) {
        return (
            <div>please wait...</div>
        )
    }


    const downLoadPo = () => {
        const data = orderDetails?.partList?.map((pro) => ({
            "productNumber": pro?.productNumber,
            "quantity": pro?.quantity,
            "manufacturer": pro?.manufacturer
        }))
        exportDataExcel(data, 'wizard Po')
    }




    return (
        <>
          <DeleteModal isOpen={!!partToDelete} heading={'part'} onClose={() => setPartToDelete(null)} onDelete={confirmPartDelete} />
            <NestedUserHeader
                index="Excess Inventory details"
                root="Dashboard"
                buttonText={'Add Subcategory'}
            />


            <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
                <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography
                            sx={{
                                color: 'rgba(29, 31, 44, 1)',
                                fontSize: '20px',
                                fontWeight: '600',
                                fontFamily: `'Public Sans', sans-serif`,
                            }}>
                            ID #{orderDetails?._id}
                        </Typography>
                        <Typography style={{
                            marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
                            color: orderDetails?.status === "NEW" ? "#4A4C56" : orderDetails?.status === "REJECTED" ? "red" : "#1A9882",
                            background: orderDetails?.status === "NEW" ? "#4A4C561A" : orderDetails?.status === "REJECTED" ? "#FFF0EA" : "#E9FAF7",
                        }}>
                            {orderDetails?.status}
                        </Typography>
                    </div>

                </div>

                {loading ? <div>Please wait...</div> :
                    <Box maxWidth="lg">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={7}>
                                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                                        <CustomerInfo />
                                        <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                            Vendor Info
                                        </Typography>
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Customer />
                                            <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                                                    Vendor:
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.fullName}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <EmailBox />
                                            <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                                                    Email:
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.email}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.email)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>
                                    <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" >
                                            <Phone />
                                            <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                                                    Phone Number:
                                                </Typography>
                                                <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                                                    {orderDetails?.userId?.phone}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <div onClick={() => handleCopy(orderDetails?.userId?.phone)}>
                                                <Copy />
                                            </div>
                                        </Box>
                                    </Box>

                                </Paper>
                            </Grid>


                            <Grid item xs={12} md={5}>
                                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", height: '100%' }}>
                                    <Box sx={{ p: 2, }} display="flex" alignItems="center" justifyContent="space-between" >
                                        <div style={{display:'flex',gap:3,alignItems:'center'}}>
                                            <CustomerInfo />
                                            <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                                                List Info
                                            </Typography>
                                        </div>
                                        {orderDetails?.status == "NEW" &&
                                        <Grid item sx={{ display: 'flex', gap: 1 }}> {/* Adds space between buttons */}
                                            <Button sx={{ color: '#E95555', fontSize: "14px", textTransform: 'capitalize' }}  onClick={()=>changeStatus('REJECTED')}>Reject</Button>
                                            <Button variant="contained" sx={{ color: '#fff', fontSize: "14px", textTransform: 'capitalize', background: '#2DA85E' }}  onClick={()=>changeStatus('APPROVED')}>Approve</Button>
                                        </Grid>
 } 
                                    </Box>
                                    <Divider sx={{ mb: 1 }} />
                                    <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                                        <Box display="flex" flexDirection="column" gap='10px'>
                                            <Box style={{ marginLeft: '8px', }} display="flex" gap='20px' alignItems='center'>
                                                <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                                                    Excess inventory list:
                                                </Typography>
                                                <Typography style={{ color: '#2D7BE8', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 5 }} >
                                                    <div onClick={downLoadPo} style={{ cursor: 'pointer' }}>

                                                        file.excel {download()}
                                                    </div>
                                                </Typography>
                                            </Box>


                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>


                        </Grid>

                        <PartList
                            data={orderDetails?.partList}
                            deleteProductFromenq={deleteProductFromenq}
                            status={orderDetails?.status}
                        />

                    </Box>
                }
            </div>
        </>
    );
};

export default VendorExcessDetails;
